import { memo } from 'react';
import type { CSSProperties } from 'react';
import { getBezierPath } from '../../core';
import type { EdgePosition } from '../../core';
import { BaseEdge } from '../BaseEdge';

/** Props every built-in edge gets: endpoints, id, style and resolved marker urls. */
export type EdgeComponentProps = EdgePosition & { id: string; style?: CSSProperties; markerStart?: string; markerEnd?: string };

export type BezierEdgeProps = EdgeComponentProps;

/** The default edge: a cubic bezier between the two handles. */
const BezierEdgeComponent = ({ id, style, markerStart, markerEnd, ...position }: BezierEdgeProps) => {
  const [path] = getBezierPath(position);
  return <BaseEdge id={id} path={path} style={style} markerStart={markerStart} markerEnd={markerEnd} />;
};

export const BezierEdge = memo(BezierEdgeComponent);
